import { CloudDownloadOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Input, message, Spin } from 'antd';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import useLoginStore from 'store/loginStore';
import { postFileUpload } from 'utils/apiFunctions.js';
import SimpleFileUpload from '../../SimpleFileUpload';


function IgImgSelector({ fgPictureUrl, setFgPictureUrl, igId }) {
    const { orgId: orgSlug } = useParams();
    const [isUploadingFromUrl, setIsUploadingFromUrl] = useState(false);
    const currentRole = useLoginStore(s => s.getCurrentRole)();
    
    const setUrlToInput = (url) => { setFgPictureUrl(url) }
    const resetUrl = () => { setFgPictureUrl(null) }

    const downloadImageFromUrl = async (url) => {
        try {
            // Use the image proxy to download the image
            const proxyUrl = `${process.env.REACT_APP_IMAGE_PROXY_URL}?url=${encodeURIComponent(url)}`;
            
            const response = await fetch(proxyUrl, {
                method: 'GET',
                credentials: 'include', // Include cookies for authentication if needed
            });
            
            if (!response.ok) {
                throw new Error(`Failed to fetch image via proxy: ${response.status} ${response.statusText}`);
            }
            
            const blob = await response.blob();
            
            // Validate that it's an image
            if (!blob.type.startsWith('image/')) {
                throw new Error('URL does not point to an image file');
            }
            
            return blob;
        } catch (error) {
            throw new Error(`Failed to download image: ${error.message}`);
        }
    };

    const uploadFromUrl = async () => {
        if (!fgPictureUrl || !fgPictureUrl.trim()) {
            message.error('Please enter a URL first');
            return;
        }

        try {
            setIsUploadingFromUrl(true);
            
            // Download the image from the URL
            const imageBlob = await downloadImageFromUrl(fgPictureUrl);
            
            // Create a file object from the blob
            const fileName = `downloaded-image-${Date.now()}.${imageBlob.type.split('/')[1] || 'jpg'}`;
            const file = new File([imageBlob], fileName, { type: imageBlob.type });
            
            // Upload the file using the existing upload infrastructure
            const response = await postFileUpload(file, { prefix: `infographics/${orgSlug}/ig${igId}` }, currentRole);
            
            if (response.status === 200) {
                const result = await response.json();
                const newUrl = result.location;
                setFgPictureUrl(newUrl);
                message.success('Image uploaded successfully from URL');
            } else {
                message.error('Failed to upload image from URL');
            }
        } catch (error) {
            console.error('Upload from URL error:', error);
            message.error(`Failed to upload from URL: ${error.message}`);
        } finally {
            setIsUploadingFromUrl(false);
        }
    };

    //console.log("IgImgSelector", fgPictureUrl, setFgPictureUrl, igId, orgSlug)

    return (
        <div className='flex gap-2'>
            <Input className='col-span-4' value={fgPictureUrl} onChange={(e) => setFgPictureUrl(e.target.value)} placeholder='http://example.com/picture.png' />
            {/* <Button 
                onClick={uploadFromUrl} 
                disabled={isUploadingFromUrl || !fgPictureUrl?.trim()}
                icon={isUploadingFromUrl ? <Spin size="small" spinning={true} /> : <CloudDownloadOutlined />}
            >
                Upload from URL
            </Button> */}
            {!fgPictureUrl && (
                <SimpleFileUpload className='col-span-1' prefix={`infographics/${orgSlug}/ig${igId}`} onUploadSuccess={setUrlToInput} />
            )}
            {fgPictureUrl && (
                <Button onClick={resetUrl} icon={<DeleteOutlined/>}>Remove</Button>
            )}
        </div>
    )
}

export default IgImgSelector

